import './INF.css';
import React from "react";

function Footer() {

    const links = [
    {
        route: "https://www.instagram.com/instantnoodlefactory/",
        label: "Instagram"
    },  {
        route: "https://www.tiktok.com/@instantnoodlefactory",
        label: "TikTok"
    }, {
        route: "mailto:inoodlefactory@gmail.com",
        label: "Mail"
    }]

    return (
        <div class="footer">
            <div class="footerFlex">
                {links.map((link) => (
                    <a className="href" href={link.route} target="_blank" rel="noreferrer">
                        <p className="footerLinkText" > {link.label} </p>
                    </a>
                ))}
            </div>
            <p className="footerText"> website managed by <a className="href" href="https://cerise-technology.com/"> Cerise Technology </a></p>
            <p className="footerText"> <a className="href" href="/"> go back to home </a></p>
        </div>
    )
}

export default Footer;